import React from 'react';
import ProductCardList from 'components/NewHome/ProductCardList';
import MobileProductModuleList from 'components/NewHome/Mobile/MobileProductModuleList';
import { windxProductsList } from 'helper/Home/productCardList';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function Windx() {
  if (useIsMobile()) {
    return <MobileProductModuleList title="WINDX" products={windxProductsList} />;
  }

  return (
    <div className="dark-outlet-background">
      <h1 className="mb-5">WINDX</h1>
      <ProductCardList products={windxProductsList} />
    </div>
  );
}
